import {useState, useEffect} from 'react'
import {Field} from 'formik'
import {getSupplierOperationTypes} from '../../core/_requests'
import {
  CustomSelect
} from '@/components/form'

const initialFilters = {
  type: ''
}

const FilterForm = () => {
  const [types, setTypes] = useState<Array<string>>([])
  const loadTypes = async () => setTypes(await getSupplierOperationTypes())

  useEffect(() => {
    types.length === 0 && loadTypes()
  })

  return (
    <>
      <Field
        default='Select type'
        component={CustomSelect}
        label="Type"
        name="type"
        options={types.map((t:string) => {
          return { value: t, label: t}
        })}
      />
    </>
  )
}

export {FilterForm, initialFilters}
